// Carry only search inputs into a fresh cabin search, never basket/booking data.
export function buildCabinReselectionPayload(payload, cruise, detailData) {
  const adults = Number(payload?.counts?.adults);
  const children = Number(payload?.counts?.children);
  const childAges = payload?.ages?.children ?? [];
  if (!Number.isInteger(adults) || adults < 1 || !Number.isInteger(children) || children < 0
    || !Array.isArray(childAges) || childAges.length !== children
    || childAges.some(age => age == null || age === '' || !Number.isFinite(Number(age)))
    || payload?.reservationCreated || payload?.passengerInfo?.bookingResult || payload?.paymentResult) return null;
  return {
    cruise, detailData,
    reservationType: payload.reservationType ?? false,
    counts: { adults, children }, ages: { children: [...childAges] },
    includeSenior: typeof payload.includeSenior === 'boolean' ? payload.includeSenior : !!payload.seniorStatus,
    pastPax: payload.pastPax ?? '',
    membershipPassengerInfo: payload.membershipPassengerInfo ?? null,
  };
}
